import { modifyTicketConfig } from '@/api/event/problem';

export const updateValue = (key, value) => {
  return modifyTicketConfig({ info: value, number: key });
};
